import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import VaccineHeader from "./Header/header";
import VaccineSidebar from "./SideBar/sidebar";
import Breadcrumbs from "../ui/Breadcrumb";
import { selectDarkMode } from "../../../app/store/slices/uiSlice";

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const darkMode = useSelector(selectDarkMode);

  // Apply dark mode class on mount
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  // Derive activeSection from current route - MATCHES APP.JSX ROUTES EXACTLY
  const getActiveSection = () => {
    const path = location.pathname;

    // Dashboard
    if (path.includes("/dashboard")) return "dashboard";

    // Vaccine Management Routes - ALL LOWERCASE KEBAB-CASE
    if (path === "/admin/vaccines" || path.startsWith("/admin/vaccines/")) return "vaccines-list";
    if (path.includes("/stock-management")) return "stock-management";
    if (path.includes("/vaccination-plan")) return "vaccination-plan";
    if (path.includes("/vaccine-dispatch")) return "vaccine-dispatch";
    if (path.includes("/vaccine-Transfer")) return "vaccine-transfer";
    if (path.includes("/vaccination-records")) return "vaccine-record";
    if (path.includes("/vaccine-receive")) return "vaccine-receive";
    if (path.includes("/supplier-management")) return "supplier-management";

    // Location Management Routes
    if (path.includes("/distric")) return "distric";
    if (path.includes("/taluka")) return "taluka";
    if (path.includes("/village")) return "village";

    // Other Routes
    if (path.includes("/centers")) return "centers";
    if (path.includes("/Appointments")) return "Appointment";
    if (path.includes("/medical-staff")) return "medical-staff";
    if (path.includes("/patients")) return "patients";
    if (path.includes("/parents")) return "parents";
    if (path.includes("/children")) return "children";
    if (path.toLowerCase().includes("/user")) return "users";
    if (path.includes("/activity-logs")) return "activity-logs";
    if (path.includes("/modules")) return "modules";
    if (path.includes("/permissions")) return "permissions";
    if (path.includes("/roles")) return "roles";

    return "dashboard";
  };

  const activeSection = getActiveSection();

  return (
    <div className={`flex h-screen transition-colors duration-300 ${darkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      {/* Sidebar - now properly integrated with routing */}
      <VaccineSidebar collapsed={collapsed} setCollapsed={setCollapsed} activeSection={activeSection} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <VaccineHeader collapsed={collapsed} setCollapsed={setCollapsed} activeSection={activeSection} />

        {/* Main Content */}
        <main
          className={`
            flex-1 overflow-auto mt-20 transition-all duration-300
            ${collapsed ? "lg:ml-[5rem] lg:w-[calc(100%-5rem)]" : "lg:ml-[18rem] lg:w-[calc(100%-18rem)]"}
            left-0 w-full absolute
          `}
        >
          {/* Breadcrumbs */}
          <div className="sm:px-9 px-6 sm:pt-6 pt-4">
            <Breadcrumbs activeSection={activeSection} darkMode={darkMode} />
          </div>

          {/* Page Content */}
          <div className={`${darkMode ? "text-gray-100" : "text-gray-900"}`}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
